export const logo = require("./logo-icon.png");
export const eye_icon = require("./eye_icon.png");
export const admin_icon = require("./admin-icon.png");
export const admin_act_icon = require("./admin-act.png");
export const user_icon = require("./user-icon.png");
export const user_act_icon = require("./user-act.png");
export const master_icon = require("./master-icon.png");
export const master_act_icon = require("./master-act.png");
export const noti_icon = require("./notification-icon.png");
export const profile_img = require("./profile-icon.png");
export const toggle_on = require("./toggle-on.png");
export const toggle_off = require("./toggle-off.png");
export const edit_icon = require("./edit-icon.png");
export const view_icon = require("./view-icon.png");
export const back_icon = require("./back-icon.png");
export const delete_icon = require("./delete-icon.png");
export const dummyimage = require("./list-img.png");
export const arrow_icon = require("./arrow-icon.png");
export const calender_icon = require("./calender-icon.png");
export const tootltip = require("./tooltip.png");
export const booking = require("./booking.png");
export const booking_act = require("./booking_act.png");
export const transaction = require("./transaction.png");
export const transaction_act = require("./transaction_act.png");
export const mmc_icon = require("./mmc-icon.png");
export const mmc_act = require("./mmc-act.png");
export const loader = require("./loader.GIF");
export const Purple_Dot = require("./Purple_Dot.png");
export const Block_active = require("./blockac.png");
export const Block_Deactive = require("./blockde.png");
export const Home_icon = require("./Home-icon.png");
export const resort_act = require("./resort-aact.png");
export const resort_inact = require("./resort-act.png");

export const vedio = require("./video-img.png");
export const drag = require("./drag-icon.png");
export const drag_img = require("./drag-img.png");

export const NoImage = require("./NoImage.png");
export const guidelines_act = require("./guidelines-act.png");
export const guidelines = require("./guidelines.png");
export const property_act = require("./properties-act.png");
export const property = require("./properties.png");
export const ReceptionistWhite = require("./ReceptionistWhite.png");
export const Receptionist = require("./Receptionist.png");

// -----sivaram-------
export const showPwdImg = require("./icon/show-password.png");
export const hidePwdImg = require("./icon/hide-password.png");
export const person1 = require("./personlogo.png");
export const Alert_icon = require("./Alert_icon.png");
export const arrow1 = require("./icon/Group1.png");
export const arrow2 = require("./icon/Group(1).png");
export const arrow3 = require("./icon/Group(2).png");
export const arrow14 = require("./icon/Group(3).png");
export const Search_icon = require("./icon/search_icon.png");
export const Switch_on = require("./icon/Switch.png");
export const Switch_off = require("./icon/off.png");
export const Home = require("./icon/home.png");
export const Person = require("./icon/Person.png");
export const Person_act = require("./icon/Person_act.png");
export const Calender = require("./icon/Calender.png");
export const image_person = require("./image_person.png");
export const Goldcoin = require("./goldcoin.png");
export const Master_icon = require("./icon/Master_icon.png");
export const Master_icon_act = require("./icon/Master_icon_act.png");
export const interest_icon = require("./icon/interest_icon.png");
export const Banner_img = require("./Banner_icon.png");
export const Check_box = require("./icon/chech_box.png");
export const Pookie = require("./Pookie.png");
export const Heart = require("./icon/Heart.png");
export const logo1 = require("./Login_logo.png");
export const dashboard_act = require("./icon/dashboard_act.png");
export const dashboard = require("./icon/dashboard.png");
export const Logout = require("./icon/Logout.png");
export const Calender_icon = require("./icon/Calender-icon.png");
export const setting_act_icon = require("./icon/setting_active_icon.png");
export const setting_icon = require("./icon/setting_icon.png");
export const circle = require("./Ellipse.png");
export const rectangle = require("./Rectangle.png");

export const download = require("./icon/Vector (3).png");
export const person2 = require("./Icon(4).png");
export const school2 = require("./Icon(5).png");
export const test2 = require("./Icon(6).png");
export const shapes2 = require("./Icon(7).png");
export const Hover_icon = require("./icon/hover_icon.png");

export const Password_View = require("./icon/Password_View.png");
export const Password_not = require("./icon/Password-not.png");

export const Loading_gif = require("./loading.gif");
export const Dummyimage1 = require("./dummyImage1.png");
export const refer_icon = require("./refer.png");
export const wishlist = require("./Wishlist.png");
export const Wallet_act = require("./Walletact.png");
export const Wallet = require("./WalletPlan.png");
export const Star = require("./Star.png");
export const review_deactive = require("./review.png");
export const review_active = require("./review_active.png");
export const coupon_active = require("./coupon-act.png");
export const coupon_deactive = require("./coupon-de.png");
export const bell_gray = require("./bell_gray.png");
export const bell_purple = require("./bell_purple.png");

export const dashboardIcon = require("./dashboardIcon.png");

export const vow_settings = require("./vow-settings.png");

export const maintanence = require("./maintanence.png");

export const act_flag = require("./act-flag.png");
export const dec_flag = require("./dec-flag.png");

export const red_flag = require("./red_flag.png");
export const blue_flag = require("./blue_flag.png");

export const white_eye = require("./white_eye.png");
export const eye_view = require("./eye.png");
export const information_Icon = require("./information.png");
export const invoice_gray_Icon = require("./invoice_gray.png");
export const invoice_purpple_Icon = require("./invoice_purpple.png");
export const cashfree_payments_logo = require("./cashfree_payments_logo.png");
export const razorpay_logo = require("./razorpay_logo.png");
export const Cardholder = require("./Cardholder.png");
export const CardholderActive = require("./CardholderActive.png");
export const SubtitlesSlashActive = require("./SubtitlesSlashActive.png");
export const SubtitlesSlash = require("./SubtitlesSlash.png");
export const ArrowBendUpLeft = require("./ArrowBendUpLeft.png");
export const cancel_icon = require("./cancel_icon.png");
export const CaretLeft = require("./CaretLeft.png");
export const eye_primary = require("./eye_primary.png");
export const Pencil = require("./Pencil.png");
export const sosactive = require("./sosactive.png");
export const sos = require("./sos.png");

export const upload_img = require("./upload-img.png");
export const edit_btn = require("./edit_btn.png");
export const new_edit = require("./new_edit.png");

export const morning_slot = require("./morning_slot.png");
export const night_slot = require("./night_slot.png");
export const delete_icon_noti = require("./delete_icon_noti.png");

export const small_calendar = require("./small_calendar.png");
export const small_time = require("./small_time.png");

// Dash board
// export const BookingIcon = require("./Booking.png");
// export const CheckOutIcon = require("./CheckOut.png");
// export const CheckInIcon = require("./CheckIn.png");
// export const UpcomingIcon = require("./Upcoming.png");
// export const CancelledIcon = require("./Cancelled.png");
// export const EarningIcon = require("./Earning.png");
// export const ListedRoomIcon = require("./.png");
